.ZaiFakeDoorModal-wrapper {
  .textContent {
    padding: 32px;
  }

  p {
    font-size: 14px;
    color: var(--color_neutral_800);
    margin-top: 32px;
  }

  .buttonsSection {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 32px;
    width: 100%;
    border-top: 1px solid var(--color_neutral_200);

    [class^="dist_buttonStyle"] {
      white-space: nowrap;
    }
  }
}